import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  ReportDesignerItemTags,
  ReportDesignerItemTagsConfig,
  ReportDesignItemTextConfig
} from "src/app/modules/bootstrap/modules/report/report-design-item";

@Component({
  selector: "snt-report-designer-tags",
  templateUrl: "report-designer-tags.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportDesignerTagsComponent implements OnInit {
  @Input() item!: ReportDesignerItemTags;
  @Input() level!: number;
  @Input() parentName!: string;

  @Output() config: EventEmitter<ReportDesignerItemTagsConfig> =
    new EventEmitter();

  formData: {
    title: string;
    category: string;
  } = {
    title: "",
    category: ""
  };

  ngOnInit(): void {
    this.formData.title = this.item.config?.title || "";
    this.formData.category = this.item.config?.category || "";
  }

  onFieldDataChanged(): void {
    this.config.emit({
      ...this.item.config,
      ...this.formData
    });
  }
}
